import classNames from 'classnames/bind';
import * as LAYOUT from './layoutTypes';

export default class WrapperClasses {

  static getWrappersClasses = (routeData, isLogged, showSidebarContent) => {
    const { pageClasses, layoutType } = routeData;
    let divPagesClasses = '';
    let rootClasses = '';
    let wrapperClasses = '';
    let userNotLogged = isLogged;

    if (layoutType === LAYOUT.DASHBOARD) {
      rootClasses = classNames(
        'main main--dashboard',
        { 'main--user-not-logged': !userNotLogged });
      wrapperClasses = 'wrapper';
    }
    if (layoutType === LAYOUT.BOOKING) {
      rootClasses = classNames(
        'main',
        { 'main--user-not-logged': !userNotLogged });
      wrapperClasses = 'wrapper';
    }
    if (layoutType === LAYOUT.ACCOUNT) {
      rootClasses = classNames(
        'main',
        { 'main--user-not-logged': !userNotLogged });
      wrapperClasses = 'wrapper';
    }
    if (layoutType === LAYOUT.HELP) {
      rootClasses = classNames(
        'main',
        { 'main--user-not-logged': !userNotLogged });
      wrapperClasses = 'wrapper';
    }
    if (layoutType === LAYOUT.AUTH) {
      rootClasses = 'root--minheight';
      wrapperClasses = 'wrapper';
      divPagesClasses = 'auth-wrapper'
    }
    if (layoutType === LAYOUT.LANDING) {
      divPagesClasses = '';
    }
    if (layoutType === LAYOUT.ACCOUNT ||
      layoutType === LAYOUT.BOOKING ||
      layoutType === LAYOUT.DASHBOARD ||
      layoutType === LAYOUT.HELP ||
      (layoutType === LAYOUT.LANDING && isLogged)) {
      divPagesClasses = classNames(`page ${pageClasses ? pageClasses : ''}`, {
        'visible': showSidebarContent,
        'hidden': !showSidebarContent
      });
    }
    return { rootClasses, wrapperClasses, divPagesClasses };
  }
}
